export default __webpack_public_path__ + "static/media/storageUnit1-afterD-2048w.10b89d61.webp";